module.exports = __webpack_public_path__ + "img/user.479f70a1.svg";